import { ref } from 'vue'

const currentTheme = ref<'geek' | 'rncp37827'>(localStorage.getItem('theme') as 'geek' | 'rncp37827' || 'rncp37827')

export function useThemeStore() {
  const setTheme = (theme: 'geek' | 'rncp37827') => {
    currentTheme.value = theme
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }

  return {
    currentTheme,
    setTheme
  }
}
